module.exports = __webpack_public_path__ + "static/media/act05.7d8988f2.mp3";